export const shouldOpenAdvancedSearchFlag = 'openAdvancedSearch';
